import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  loadList: [],
  loadCount: 0,
  driverList: [],
  vehicleList: [],
  vehicleCount: 0,
  driverCount: 0,
  selectedList: [],
  subCatList: [],
  bidData: [],
  loadingPending: false,
  bidProcessing: false,
  plannedList: [],
};
export default function tripDesignCRUDReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_TRIP_CRUD_LOAD_SUCCESS_ACTION:
      return {
        ...state,
        loadList: action.payload.rows,
        loadCount: action.payload.count,
      };

    case actionTypes.UPDATE_TRIP_PLAN_CRUD_LOAD_INIT_ACTION:
      return {
        ...state,
        processing: true,
        loadingPending: true,
      };

    case actionTypes.UPDATE_TRIP_PLAN_CRUD_LOAD_SUCCESS_ACTION:
      return {
        ...state,
        processing: true,
        loadingPending: false,
      };

    case actionTypes.UPDATE_TRIP_CRUD_LOAD_FAIL_ACTION:
      return {
        ...state,
        processing: true,
        loadingPending: false,
      };

    case actionTypes.UPDATE_TRIP_PLAN_PROCESSING_INIT_ACTION:
      return {
        ...state,
        processing: false,
      };

    case actionTypes.UPDATE_TRIP_CRUD_LOAD_FAIL_ACTION:
      return {
        ...state,
        processing: false,
      };

    case actionTypes.UPDATE_TRIP_CRUD_LOAD_FAIL_ACTION:
      return {
        ...state,
        processing: false,
      };

    case actionTypes.FETCH_LOAD_DRIVER_SUCCESS_ACTION:
      return {
        ...state,
        driverList: action.payload.rows,
        driverCount: action.payload.count,
      };

    case actionTypes.FETCH_LOAD_VEHICLE_SUCCESS_ACTION:
      return {
        ...state,
        vehicleList: action.payload.rows,
        vehicleCount: action.payload.count,
      };

    case actionTypes.FETCH_UPDATE_SINGLE_LOAD_DATA_ACTION:
      return {
        ...state,
        selectedList: action.params,
      };

    case actionTypes.SELECTED_LOAD_INIT_ACTION:
      return {
        ...state,
        selectedList: action.payload,
      };

    case actionTypes.DELETE_SELECTED_LOAD_INIT_ACTION:
      return {
        ...state,
        selectedList: state.selectedList.filter((ele) =>
          action.payload.trip === true
            ? ele.tripRefNo !== action.payload.item
            : ele.loadRefNo !== action.payload.item
        ),
      };

    case actionTypes.FETCH_TRIP_PLAN_BY_ID_INIT_ACTION:
      return {
        ...state,
        plannedList: [],
      };

    case actionTypes.FETCH_TRIP_PLAN_BY_ID_SUCCESS_ACTION:
      return {
        ...state,
        plannedList: action.payload,
      };
    case actionTypes.FETCH_LOAD_BY_IDS_INIT_ACTION:
      return {
        ...state,
        selectedList: [],
      };
    case actionTypes.FETCH_LOAD_BY_IDS_INIT_SUCCESS_ACTION:
      return {
        ...state,
        selectedList: action.payload.rows,
      };

    case actionTypes.FETCH_VEHICLE_SUB_CAT_INIT_SUCCESS_ACTION:
      return {
        ...state,
        subCatList: action.payload.rows,
        countSubCatList: action.payload.count,
      };

    case actionTypes.FETCH_BID_BY_INIT_ACTION_TRIP_DESIGN_SUCCESS_ACTION:
      return {
        ...state,
        bidData: action.payload.rows,
      };
    case actionTypes.CREATE_BID_INIT_ACTION:
      return {
        ...state,
        bidProcessing: true,
      };
    case actionTypes.CREATE_BID_INIT_ACTION_SUCCESS_ACTION:
      return {
        ...state,
        bidProcessing: false,
      };
    case actionTypes.FETCH_PAYMNT_INIT_SUCCESS_ACTION:
      return {
        ...state,
        paymntDetail: action.payload.rows[0],
      };
    case actionTypes.CLEAR_SELECTED_LIST:
      return {
        ...state,
        selectedList: [],
        plannedList: [],
      };
    default:
      return {
        ...state,
      };
  }
}
